import { getKyClient } from './client';

export const fetchAccountInfo = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/TransactionsSummary`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchAllTransactions = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/Transactions`;
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

const s2ab = (s) => {
  let buf = new ArrayBuffer(s.length);
  let view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
};

export const downloadTransactionsService = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/DownloadTransactionsExcel`;
  const kyClient = await getKyClient();
  const result = await kyClient.get(url).json();
  let decoded = window.atob(result);
  let ab = s2ab(decoded);
  let blob = new Blob([ab], { type: 'application/vnd.ms-excel' });
  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'Transaction(' + adfitNo + ').xlsx';
  link.click();
};
